import { algoliasearch } from "algoliasearch";

export const searchClient = algoliasearch(process.env.REACT_APP_ALGOLIA_API_ID, process.env.REACT_APP_ALGOLIA_API_KEY);